// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-family: var(--ion-font-family);
  letter-spacing: 1px;
}

.contentcard {
  background: var(--ion-color-white);
  padding: 0;
}
.contentcard .headingName {
  display: flex;
  flex-direction: row;
  gap: 1vw;
  margin: 5vw 4vw;
  font-size: 20px;
  letter-spacing: 1px;
  font-weight: 500;
  justify-content: center;
  align-items: flex-end;
}
.contentcard ion-list {
  margin-bottom: 0px;
}
.contentcard ion-list ion-list-header ion-label {
  margin: 0;
  font-size: 16px;
}
.contentcard ion-list ion-item {
  --padding-start: 0;
  font-size: 14px;
  --inner-padding-start: 22px;
}

.appBtnIcon {
  height: 5vw;
  max-width: 5vw;
  min-width: 5vw;
  margin: 0vw;
  font-size: 16px;
}

.submitIcon {
  color: var(--ion-bright-success);
}

.closeIcon {
  color: var(--ion-bright-danger);
}

.appBtn {
  display: flex;
  flex-direction: row;
  gap: 2vw;
  margin: 0vw;
  padding: 1vw 3vw;
  width: 100%;
  height: 12vw;
  font-size: 16px;
  letter-spacing: 1px;
  justify-content: space-evenly;
  align-items: center;
}

.modalFooter {
  display: flex;
  margin: 0;
  padding: 4vw;
  flex-direction: row-reverse;
  gap: 4vw;
  align-items: center;
  justify-content: space-between;
  background: var(--ion-lighter-primary);
  --background: var(--ion-white-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/menu/customization-modal/customization-modal.page.scss"],"names":[],"mappings":"AAWA;EACA,mCAAA;EACA,mBAAA;AAVA;;AAYA;EACA,kCAAA;EACC,UAAA;AATD;AAaC;EACG,aAAA;EAEA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAZJ;AAcC;EACC,kBAAA;AAZF;AAeG;EACC,SAAA;EACA,eAAA;AAbJ;AAiBE;EACC,kBAAA;EACA,eAAA;EACA,2BAAA;AAfH;;AA+BA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AA5BF;;AA+BA;EAEE,gCAAA;AA7BF;;AA+BA;EACC,+BAAA;AA5BD;;AA8BA;EACI,aAAA;EAEA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACH,YAAA;EACG,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AA5BJ;;AA+BA;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,sCAAA;AA5BF","sourcesContent":["// ion-header {\n// \tion-toolbar{\n//     background: var(--ion-color-medium)!important ;\n//     --background: var(--ion-color-medium)!important ;\n// \tion-title {\n// \t\tfont-weight: 200;\n// \t\tfont-size: 24px;\n// \t\tline-height: 36px;\n// \t}\n// }\n// }\n:root{\nfont-family: var(--ion-font-family);\nletter-spacing: 1px;\n}\n.contentcard {\nbackground: var(--ion-color-white);\n\tpadding: 0;\n\t// min-height: 50vh;\n    // background: var(--ion-color-medium)!important ;\n    // --background: var(--ion-color-medium)!important ;\n\t.headingName{\n    display: flex\n;\n    flex-direction: row;\n    gap: 1vw;\n    margin: 5vw 4vw;\n    font-size: 20px;\n    letter-spacing: 1px;\n    font-weight: 500;\n    justify-content: center;\n    align-items: flex-end;\n}\n\tion-list {\n\t\tmargin-bottom: 0px;\n\n\t\tion-list-header {\n\t\t\tion-label {\n\t\t\t\tmargin: 0;\n\t\t\t\tfont-size: 16px;\n\t\t\t}\n\t\t}\n\n\t\tion-item {\n\t\t\t--padding-start: 0;\n\t\t\tfont-size: 14px;\n\t\t\t--inner-padding-start: 22px;\n\t\t}\n\t}\n}\n\n// ion-footer {\n// \tmargin-bottom: 0px;\n//     // background: var(--ion-color-medium)!important ;\n//     // --background: var(--ion-color-medium)!important ;\n// \tion-button {\n// \t\t//min-height: 40px;\n// \t\tcolor: #fff;\n// \t\t--color: #fff;\n// \t}\n// }\n\n.appBtnIcon {\n  height: 5vw;\n  max-width: 5vw;\n  min-width: 5vw;\n  margin: 0vw;\n  font-size: 16px;\n \n}\n.submitIcon{\n  // stroke: var(--ion-color-success);\n  color: var(--ion-bright-success);\n}\n.closeIcon{\n\tcolor: var(--ion-bright-danger);\n}\n.appBtn{\n    display: flex\n;\n    flex-direction: row;\n    gap: 2vw;\n    margin: 0vw;\n    padding: 1vw 3vw;\n    width: 100%;\n\theight: 12vw;\n    font-size: 16px;\n    letter-spacing: 1px;\n    justify-content: space-evenly;\n    align-items: center;\n    // color: var(--ion-text-primary);\n}\n.modalFooter {\n  display: flex;\n  margin: 0;\n  padding: 4vw;\n  flex-direction: row-reverse;\n  gap: 4vw;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--ion-lighter-primary);\n  --background: var(--ion-white-primary);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
